export const PAYMENT_REFUND_MIN_AMOUNT = 0.01;
